import React from 'react'
import { Stack, Typography } from '@mui/material'
import type { OrgMemberRow } from 'pure-js/types/OrganizationMembership'

import { Button } from '../../../../interaxDesignSystemComponents'
import { DefaultModal } from '../../../../shared/components/DefaultModal'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'

interface RequestGoalsConfirmModalProps {
  target: OrgMemberRow | null
  onClose: () => void
  onConfirm: () => void
  isPending: boolean
}

/** Confirms re-opening a member's goal-setting step, matching the sibling member-action modals. */
export const RequestGoalsConfirmModal: React.FC<RequestGoalsConfirmModalProps> = ({
  target,
  onClose,
  onConfirm,
  isPending
}) => {
  const { t } = useTranslation()
  const memberLabel = target?.displayName || target?.email || target?.userId

  return (
    <DefaultModal isOpen={target !== null} onClose={onClose} maxWidth="420px">
      <Stack spacing={2.5}>
        <Typography sx={{ fontSize: '20px', fontWeight: 600, color: INTERAX_COLORS.white }}>
          {t('org.members.requestGoalsTitle')}
        </Typography>
        {target && (
          <Typography sx={{ fontSize: '14px', color: INTERAX_COLORS.white70, lineHeight: 1.5 }}>
            {t('org.members.requestGoalsBody', { name: memberLabel })}
          </Typography>
        )}
        <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
          <Button variant="secondary" size="small" onClick={onClose} data-testid="org-request-goals-cancel">
            {t('org.members.invite.cancel')}
          </Button>
          <Button
            variant="primary"
            size="small"
            onClick={onConfirm}
            disabled={isPending}
            data-testid="org-request-goals-confirm"
          >
            {t('org.members.requestGoalsConfirm')}
          </Button>
        </Stack>
      </Stack>
    </DefaultModal>
  )
}
